import { render, staticRenderFns } from "./ProblemEditPopup.vue?vue&type=template&id=3da07b2c&scoped=true&"
import script from "./ProblemEditPopup.vue?vue&type=script&lang=js&"
export * from "./ProblemEditPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProblemEditPopup.vue?vue&type=style&index=0&id=3da07b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da07b2c",
  null
  
)

export default component.exports